'use client';
import { usePathname } from 'next/navigation';

import Script from 'next/script';

import { AssetStoryblok } from '@monoimin/sb-types';
import { adjustPathname, getUrlOrigin } from '@monoimin/utils/helpers';
export function AudioSchema({
  audio,
  heading,
  lead,
}: {
  audio: AssetStoryblok;
  heading: string;
  lead: string;
}) {
  const pathname = usePathname();
  const schemaData = {
    '@context': 'https://schema.org/',
    '@type': 'AudioObject',
    contentUrl: audio?.filename,
    description: lead,
    name: heading,
    url: adjustPathname(getUrlOrigin() + pathname),
    creator: {
      '@type': 'Thing',
      name: 'Immigrant Invest',
    },
    author: {
      '@type': 'Thing',
      name: 'Immigrant Invest',
    },
  };
  return (
    <Script id='audio-jsonld' type='application/ld+json'>
      {JSON.stringify(schemaData)}
    </Script>
  );
}

export default AudioSchema;
